import React from 'react';

import { Anchor, Text } from '@zillow/constellation-10';

export type DisclaimerItem = {
  header?: string;
  description?: Array<{
    text: string;
    url?: string;
    stylings?: Array<string>;
  }>;
};

export type FormatDisclaimerContentOptions = {
  styledTextList: DisclaimerItem['description'];
  fontType?: string;
};

export function formatDisclaimerContent({
  styledTextList,
  fontType = 'legal',
}: FormatDisclaimerContentOptions): React.ReactNode {
  if (!styledTextList?.length) {
    return null;
  }

  return (
    <>
      {styledTextList.map((styledText, i) => {
        const key = `styled-text-${i}`;
        const content = styledText.url ? (
          <Anchor target="_blank" href={styledText.url}>
            {styledText.text}
          </Anchor>
        ) : (
          styledText.text
        );
        const isEmphasized = styledText.stylings?.includes('emphasize');
        return (
          <Text
            key={key}
            textStyle={fontType === 'legal' ? 'body-xs' : 'body'}
            color="text.subtle"
            css={{
              whiteSpace: 'pre-line',
              ...(isEmphasized ? { fontWeight: 'bold' } : {}),
            }}
          >
            {content}
          </Text>
        );
      })}
    </>
  );
}
